module.exports = __webpack_public_path__ + "src/img/artist/work02_3.jpg?a79a6140bcf0725e4480bdc534e12140";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/work02_3.jpg
// module id = 150
// module chunks = 0